// extracted by mini-css-extract-plugin
export default {"loaderPage":"FullPageLoader_loaderPage__OydjP","loader":"FullPageLoader_loader__0yhss","l4":"FullPageLoader_l4__ECJ0U","loaderText":"FullPageLoader_loaderText__JHbJc"};